var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentSupp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3463 5.345L12.9896 2.98833C12.6771 2.67583 12.253 2.5 11.8113 2.5H5.83464C4.9138 2.5 4.16797 3.24583 4.16797 4.16667V15.8333C4.16797 16.7542 4.9138 17.5 5.83464 17.5H14.168C15.0888 17.5 15.8346 16.7542 15.8346 15.8333V6.52333C15.8346 6.08167 15.6588 5.6575 15.3463 5.345V5.345Z",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8346 6.66667H12.5013C12.0413 6.66667 11.668 6.29333 11.668 5.83333V2.5",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSupp);
export default __webpack_public_path__ + "static/media/documentSupp.dda088f14513ad67a81a3cb233661e4d.svg";
export { ForwardRef as ReactComponent };